import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import Button from '../../Atoms/Button';
import Img, { Props as ImgProps } from '../../Atoms/Image';

export interface Props {
  title: string;
  subtitle: string;
  text: string;
  textClassname?: string;
  url: string;
  img: ImgProps;
}

function CardReview({
  title,
  text,
  textClassname,
  subtitle,
  img,
  url
}: Props) {
  return (
    <div className="CardReview mx-auto flex max-w-sm flex-col-reverse items-stretch gap-5 lg:max-w-3xl lg:flex-row">
      <div className="CardReviewText flex w-full flex-col items-start justify-center gap-5 text-white">
        <Title as="h2" size={3} color="inherit">
          {title}
        </Title>
        <Text color="inherit">{subtitle}</Text>
        <Text color="inherit" className={textClassname}>
          {text}
        </Text>
        {url && (
          <Button
            as="a"
            href={url}
            color="secondary"
            text="Lees meer"
            iconName="arrow-right"
            shadow
          />
        )}
      </div>
      <div className="CardReviewImage flex w-full items-center justify-center">
        <Img
          className="h-auto w-full rounded-xl object-cover object-center"
          {...img}
        />
      </div>
    </div>
  );
}

export default CardReview;
